import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'

// actions
const ACTION_PREFIX = 'tenant/roles'
const START_FETCHING_ROLES = `${ACTION_PREFIX}/startFetchingRoles`
const FINISHED_FETCHING_ROLES = `${ACTION_PREFIX}/finishedFetchingRoles`
const ERROR_FETCHING_ROLES = `${ACTION_PREFIX}/errorFetchingRoles`

// reducer
const initialState = {
  isLoading: false,
  error: null,
  roles: [],
  rolesMeta: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FINISHED_FETCHING_ROLES:
      const { roles, rolesMeta } = action
      return { ...state, roles, rolesMeta, isLoading: false }

    case START_FETCHING_ROLES:
      return { ...state, isLoading: true, error: null }

    case ERROR_FETCHING_ROLES:
      const { error } = action
      return { ...state, roles, error }

    default:
      return state
  }
};

const startFetchingRoles = () => {
  return {
    type: START_FETCHING_ROLES,
  }
}

const finishedFetchingRoles = (roles, rolesMeta) => {
  return {
    type: FINISHED_FETCHING_ROLES,
    roles,
    rolesMeta,
  }
}

const errorFetchingRoles = (error) => {
  return {
    type: ERROR_FETCHING_ROLES,
    error,
  }
}

export const fetchRoles = () => {
  return (dispatch) => {
    dispatch(startFetchingRoles())
    request(settingsConfig.tenantRolesUrl, { auth: true })
      .then((response) => {
        const {
          body: {
            data: roles,
            meta: rolesMeta,
          },
        } = response

        dispatch(finishedFetchingRoles(roles, rolesMeta))
      })
      .catch((error) => {
        dispatch(errorFetchingRoles(error))
      })
  }
}
